import { LocaleDirection } from 'onfido-sdk-ui/types/shared/Types';
import { CommonDataDTO } from '@app/requests/model/combos-model';

export interface InvestDetailOperationRequestDTO {
  dateFrom: string;
  dateTo: string;
  divisionId: string;
  groupId: string;
  prescriberId: string;
  establishmentId: string;
  orderType: OrderType;
}

export interface InvestmentDetailsOperation {
  userId: string;
  userDesc: string;
  contractId: number;
  holderName: string;
  finProd: string;
  autDate: string;
  invest: number;
  tin: number;
  incentive: number;
  deadlines: number;
  description: string;
  brand: string;
  model: string;
  strSeg: string;
  rappel: string;
}

export interface InvestDetailOperationAgent {
  labelGroup: string;
  dataGroup: InvestmentDetailsOperation[];
  totals: InvestDetailOperationTotals;
}

export interface PenaltyDetailDTO {
  labelGroup: string;
  dataGroup: ReportIncentiveAgentResponseDTO[];
  totals: InvestDetailOperationTotals;
}

export interface ReportIncentiveAgentResponseDTO {
  userId: string;
  userDesc: string;
  contractId: number;
  holderName: string;
  productId: string;
  productDesc: string;
  autDate: string;
  deadlines: number;
  invest: number;
  tin: number;
  incentive: number;
  description: string;
  cancelDate: string;
}

export interface InvestDetailOperationTotals {
  totalInvest: number;
  totalIncent: number;
}

// TO DO: CAMBIAR CUANDO ESTE EL MODELO FINAL

export interface totalAgentStatisticsMock {
  totalOperations: string;
  totalInvestment: string;
  totalTIR: string;
  totalPI: string;
  totalCommissionAgents: string;
  totalPercentageCommission: string;
  totalCommissions: string;
}

export enum OrderType {
  Agents = 'E',
  NifCif = 'P',
}

export enum AgentType {
  Group = 'C',
  NifCif = 'E',
  Agent = 'P',
}

export interface InvestProductsDTO {
  dateFrom: string;
  dateTo: string;
  divisionId: string;
  groupId: string;
  prescriberId: string;
  establishmentId: string;
}
export interface DetailByOperation {
  registerOffice: string;
  request: string;
  customerName: string;
  originAgent: string;
  vendor: string;
  investment: string;
  product: string;
  article: string;
  calification: string;
  brand: string;
  entrance: string;
  resolution: string;
  payDate: string;
  division: string;
  security: string;
  tir: string;
  investmentComplement: string;
}

export interface DetailByOperationDTO {
  detailByOperation: DetailByOperation[];
  state: string;
}

export interface TotalInvestmentProductsDTO {
  financialProduct: string;
  numOperations: number;
  mainFunding: number;
  incentive: number;
  protections: number;
  financialSegs: number;
  totalInvest: number;
}

export interface InvestmentProductsDTO {
  monthYear: string;
  financialProduct: string;
  numOperations: number;
  mainFunding: number;
  incentive: number;
  protections: number;
  financialSegs: number;
  overTotal: number;
  totalInvest: number;
  grouping: string;
  groupingId: string;
  totals?: TotalInvestmentProductsDTO;
}

export interface InvestmentByProductsDTO {
  invProductsbyMonthYear: InvestmentProductsDTO[];
  invAccumulated: InvestmentProductsDTO[];
}

export interface AgentStatsRequestDTO {
  fromDate: string;
  toDate: string;
  divisionId: string;
  officeId: string;
  productId: string;
  articleId: string;
  chainId: string;
}

export interface AgentStatsDTO {
  officeId: string;
  officeDescription: string;
  establishmendId: string;
  userDesc: string;
  numOperations: number;
  inversion: number;
  tirAverage: number;
  termsAverage: number;
  agentCommission: number;
  percentCommission: number;
  totalCommissions: number;
}

export interface AgentGroupDTO {
  officeId: string;
  name: string;
  totalNumOperations: number;
  totalInversion: number;
  totalTirAverage: number;
  totalTermsAverage: number;
  totalAgentCommission: number;
  totalPercentCommission: number;
  totalCommissions: number;
  items: AgentStatsDTO[];
}

export interface AgentStatsReportDTO {
  totalInversion: number;
  totalNumOperations: number;
  totalTirAverage: number;
  totalTermsAverage: number;
  totalAgentCommission: number;
  totalPercentCommission: number;
  totalCommissions: number;
  items: AgentGroupDTO[];
}

export interface AgentStatsExport {
  establishmendId: string;
  userDesc: string;
  numOperations: string;
  inversion: string;
  tirAverage: string;
  termsAverage: string;
  agentCommission: string;
  percentCommission: string;
  totalCommissions: string;
}
export interface GeneralInvestmentRequestDTO {
  officeId: string;
  fromDate: string;
  toDate: string;
  divisionId: string;
  productId: string;
  originId: string;
  articleId: string;
}

export interface GeneralInvestmentDTO {
  articleId: string;
  articleDescription: string;
  sectorId: string;
  serctorDescription: string;
  numOperations: number;
  inversion: number;
  totalPortion: number;
  termsAverage: number;
  tirAverage: number;
  percentInTotalInversion: any;
}

export interface GeneralInvestmentReportDTO {
  items: GeneralInvestmentDTO[];
  total: any;
}

export interface PDFGralInvestRow {
  articleName: string;
  numOperations: string;
  investment: string;
  totalPortion: string;
  termsAverage: string;
  tirAverage: string;
}

export interface ExternalComercialDTO {
  officeId: string;
  prescriberId: string;
  chainId: string;
  establishmentId: string;
  externalCommercialUserId: string;
}

export interface OperationValidationRequest {
  fromDate: string;
  toDate: string;
  officeId: string;
  externalCommercialUserId: string;
  documentStatus: string;
  statusRequestCodes: string[];
}

export interface OperationValidationItem {
  statusRequest: string;
  contractNumber: number;
  numRequest: string;
  businessName: string;
  statusDesc: string;
  holderDoc: string;
  documentDesc: string;
  documentStatus: string;
  creationDate: any; //alta incidencia
  formalizationDate: any; //fecha formalizacion
  validationDate: Date;
  domain: string;
  expirationDate: any; //primer vencimiento
}

export interface ItemWithStatus {
  statusRequest: string;
  statusDesc: string;
  items: OperationValidationItem[];
}

export interface OperationValidationResponse {
  elements: ItemWithStatus[];
}

export interface ActionAgentReportDTO {
  group: string;
  totalCurrent: ActionAgentTotal;
  current: ActionAgentMonth[];
  totalPrevious: ActionAgentTotal;
  previous: ActionAgentMonth[];
}

export interface ActionAgentReportResponseDTO {
  totalPages: number;
  groups: ActionAgentReportDTO[];
}

export interface ActionAgentTotal {
  year: string;
  investment: number;
  group: string;
  numOps: number;
  flexic: number;
  ppt: number;
  ppb: number;
  ppp: number;
  tir: number;
  totalCommision: number;
  safeCommision: number;
  feeCommision: number;
  usoInfo: number;
}

export interface ActionAgentMonth {
  monthYear: string;
  investment: number;
  group: string;
  numOps: number;
  flexic: number;
  ppt: number;
  ppb: number;
  ppp: number;
  tir: number;
  totalCommision: number;
  safeCommision: number;
  feeCommision: number;
  usoInfo: number;
}

export enum CustomerDetail {
  C = 'C',
  E = 'E',
  P = 'P',
}

export interface ControlPanelPaginationDTO {
  pageSize?: number;
  pageIndex?: number;
}

export interface AgentActionPlanDTO extends ControlPanelPaginationDTO {
  divisionId: string;
  officeId: string;
  chainId: string;
  prescriberId: string;
  establishmentId: string;
  externalCommercialId: string;
  customerDetail: CustomerDetail;
}

export class AgentActionPlanClass implements AgentActionPlanDTO {
  divisionId: string;
  officeId: string;
  chainId: string;
  prescriberId: string;
  establishmentId: string;
  externalCommercialId: string;
  customerDetail: CustomerDetail;
  pageSize?: number;
  pageIndex?: number;

  constructor(
    divisionId: string,
    officeId: string,
    chainId: string,
    prescriberId: string,
    establishmentId: string,
    externalCommercialId: string,
    customerDetail: CustomerDetail
  ) {
    this.divisionId = divisionId;
    this.officeId = officeId;
    this.chainId = chainId;
    this.prescriberId = prescriberId;
    this.establishmentId = establishmentId;
    this.externalCommercialId = externalCommercialId;
    this.customerDetail = customerDetail;
  }
}

export interface AgentActionPlanSearchDTO extends ControlPanelPaginationDTO {
  divisionId: CommonDataDTO;
  officeId: CommonDataDTO;
  chainId: CommonDataDTO;
  prescriberId: CommonDataDTO;
  establishmentId: CommonDataDTO;
  externalCommercialId: CommonDataDTO;
  customerDetail: CustomerDetail;
}

export interface AgentActionRequestDTO {
  officeId: string;
  prescriberId: string;
  chainId: string;
  establishmentId: string;
  externalCommercialUserId: string;
}

export interface OperationDetailRequestDTO {
  divisionId: string;
  officeId: string;
  reqStatusId: string;
  groupId: string;
  agentId: string;
  extCommercialId: string;
  origin: string;
  fromDate: string;
  toDate: string;
}

export interface ReqOpsDetailsDTO {
  monthYear: string;
  regOffice: string;
  requestNumber: string;
  customerName: string;
  origAgent: string;
  seller: string;
  investment: number;
  productId: string;
  articleId: string;
  brandRating: string;
  brand: string;
  entryDate: string;
  resolutionDate: string;
  paymentDate: string;
  divisionId: string;
  situationId: string;
  statusDes: string;
  over: string;
  tir: number;
  seg: string;
  operationNumber: number;
  totalFunding: number;
  halfTir: number;
}

export interface ReqIncentiveDetailsDTO {
  establishmentId: string;
  dateFrom: string;
  dateTo: string;
  pageIndex: number;
  pageSize: number;
}

export interface ReqIncentiveDetailsDTOInfo {
  contractId: number;
  holderName: string;
  productDesc: string;
  autDate: string;
  codBeneficiary: string;
  beneficiary: string;
  sign: string;
  amountPenalty: any;
  reason: string;
  penalty: string;
}

export interface ReqIncentiveDetailsDTOResponse {
  numPages: number;
  pageSize: number;
  pageIndex: number;
  establishmentName: string;
  results: ReqIncentiveDetailsDTOInfo[];
}

export interface ActionAgentExcelData {
  fileName: string;
  header: Array<string[]>; // Headers
  column: Array<number[]>; // Data
  title: string;
}

export interface PdfComboHeaderDTO {
  header: string;
  body: string;
}

export interface PdfSearchDTO {
  division: PdfComboHeaderDTO;
  office: PdfComboHeaderDTO;
  chain: PdfComboHeaderDTO;
  prescriber: PdfComboHeaderDTO;
  establishment: PdfComboHeaderDTO;
  externalCommercial: PdfComboHeaderDTO;
  customerDetail?: PdfComboHeaderDTO;
}
